import * as React from 'react'
import { Props } from './EmployeePreview'

export function EmployeeDisplay(props: Props) {
  const { referral } = props

  return <>{`${referral.referralValue}`}</>
}
